import React, { useState } from 'react';
import './ContactForm.css';

const isValidPhone = (value) => {
  const digits = (value || '').replace(/\D/g, '');
  if (digits.length < 10 || digits.length > 15) return false;
  if (digits.length === 10 && digits[0] !== '0') return false; // FR: 0X XX XX XX XX
  if (digits.length === 11 && !digits.startsWith('33')) return false; // FR: +33 X XX XX XX XX
  return true;
};

const ContactForm = ({ isSidebar = false }) => {
  const [formData, setFormData] = useState({
    name: '',
    phone: '',
    email: '',
    message: ''
  });

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitMessage, setSubmitMessage] = useState('');
  const [submitStatus, setSubmitStatus] = useState(''); // 'success' | 'error'

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitMessage('');
    setSubmitStatus('');

    if (!isValidPhone(formData.phone)) {
      setSubmitMessage('Veuillez entrer un numéro de téléphone valide (ex. 06 12 34 56 78 ou +33 6 12 34 56 78).');
      setSubmitStatus('error');
      setIsSubmitting(false);
      return;
    }

    try {
      const res = await fetch('/api/send-email', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          type: 'contact',
          name: formData.name,
          email: formData.email,
          phone: formData.phone,
          message: formData.message
        })
      });
      const data = await res.json();

      if (res.ok) {
        setSubmitMessage('Message envoyé avec succès ! Nous vous contacterons bientôt.');
        setSubmitStatus('success');
        setFormData({ name: '', phone: '', email: '', message: '' });
      } else {
        setSubmitMessage(data.error || 'Erreur lors de l\'envoi. Réessayez ou contactez-nous au 09 52 65 50 19.');
        setSubmitStatus('error');
      }
    } catch (err) {
      setSubmitMessage('Erreur de connexion. Vérifiez votre réseau ou contactez-nous au 09 52 65 50 19.');
      setSubmitStatus('error');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className={`contact-form-wrapper ${isSidebar ? 'sidebar' : ''}`}>
      <div className="contact-form-container">
        <h2 className="contact-form-title">Nous Contacter</h2>
        <p className="contact-form-description">
          Pour toute question ou inscription, contactez-nous !
        </p>
        <form className="contact-form" onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="name">Nom</label>
            <input
              type="text"
              id="name"
              name="name"
              value={formData.name}
              onChange={handleChange}
              required
              placeholder="Votre nom"
            />
          </div>
          <div className="form-group">
            <label htmlFor="phone">Téléphone</label>
            <input
              type="tel"
              id="phone"
              name="phone"
              value={formData.phone}
              onChange={handleChange}
              required
              placeholder="Votre numéro de téléphone"
              pattern="[\d\s\-\.\+]{10,}"
              title="Ex. 06 12 34 56 78 ou +33 6 12 34 56 78"
            />
          </div>
          <div className="form-group">
            <label htmlFor="email">Email</label>
            <input
              type="email"
              id="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              required
              placeholder="votre@email.com"
            />
          </div>
          <div className="form-group">
            <label htmlFor="message">Votre Message</label>
            <textarea
              id="message"
              name="message"
              value={formData.message}
              onChange={handleChange}
              required
              rows="5"
              placeholder="Votre message..."
            />
          </div>
          <button type="submit" className="btn btn-orange" disabled={isSubmitting}>
            {isSubmitting ? 'Envoi...' : 'Envoyer'}
          </button>
          {submitMessage && (
            <p className={`submit-message ${submitStatus}`}>{submitMessage}</p>
          )}
        </form>
      </div>
    </div>
  );
};

export default ContactForm;
